<template>
  <v-btn x-small color="primary" text @click="$emit('clearFilter')"
    >Clear</v-btn
  >
</template>
<script>
export default {};
</script>
